import { HStack, Text } from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';
import { SlidersHorizontal } from 'lucide-react';

// Feed-header trigger that opens the filter modal, with a count badge when filters are
// applied so their presence is visible without opening the sheet.
const FilterButton = ({ activeCount, onClick }: { activeCount: number; onClick: () => void }) => (
  <HStack
    as="button"
    type="button"
    onClick={onClick}
    aria-label="Filters"
    gap="8px"
    paddingX="16px"
    height="42px"
    borderRadius="full"
    backgroundColor="white"
    color={activeCount > 0 ? 'primary.500' : 'text.mediumBlue'}
    boxShadow="0px 4px 16px rgba(14, 0, 98, 0.07)"
    transition="color 0.15s ease"
    _hover={{ color: 'primary.500' }}
  >
    <SlidersHorizontal size={18} strokeWidth={2.2} />
    <Text fontSize="14px" fontWeight={700}>
      Filters
    </Text>
    {/* The badge springs in when filters are first applied and pops on each count change,
        so the effect of tapping Apply is felt without opening the sheet. */}
    <AnimatePresence initial={false}>
      {activeCount > 0 && (
        <motion.div
          key="badge"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0, opacity: 0 }}
          transition={{ type: 'spring', stiffness: 600, damping: 24 }}
          style={{ display: 'inline-flex' }}
        >
          <HStack justify="center" minWidth="20px" height="20px" paddingX="6px" borderRadius="full" backgroundColor="primary.500" color="white">
            {/* Keyed on the count so the number itself pops on each change. */}
            <Text as={motion.span} key={activeCount} initial={{ scale: 0.5 }} animate={{ scale: 1 }} fontSize="12px" fontWeight={700}>
              {activeCount}
            </Text>
          </HStack>
        </motion.div>
      )}
    </AnimatePresence>
  </HStack>
);

export default FilterButton;
